import { motion } from "framer-motion";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";
import { IMG_STONE_DUSK } from "../lib/product";

const AboutVision = () => (
    <section
        id="vision-section"
        data-testid="vision-section"
        className="relative overflow-hidden bg-surface/40 py-24 lg:py-36"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    OUR VISION
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    V.01
                </p>
            </motion.div>

            <div className="mt-14 grid items-end gap-12 lg:grid-cols-12">
                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                    className="lg:col-span-7"
                >
                    <h2
                        data-testid="vision-headline"
                        className="max-w-2xl font-display text-4xl font-semibold leading-[1.1] text-white md:text-5xl"
                    >
                        A more informed future for residential construction
                        <span className="text-accent">.</span>
                    </h2>
                    <p className="mt-8 max-w-xl text-[16px] leading-relaxed text-mist">
                        Our vision is to make residential construction more
                        transparent, accessible and intelligent across South
                        Africa and, over time, the broader African market.
                    </p>
                    <p className="mt-5 max-w-xl text-[16px] leading-relaxed text-mist">
                        We see a future where homeowners can better understand
                        their homes before construction begins, evaluate
                        important decisions as projects progress and access
                        meaningful construction intelligence without having to
                        navigate fragmented information.
                    </p>
                    <p className="mt-5 max-w-xl text-[16px] leading-relaxed text-mist">
                        We are building towards a construction ecosystem where
                        technology and industry knowledge work together to
                        simplify the building experience. BuildEase is
                        committed to continuously developing intelligence
                        capabilities that support better-informed construction
                        decisions.
                    </p>
                </motion.div>

                <motion.figure
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                    data-testid="vision-figure"
                    className="group lg:col-span-5"
                >
                    <div className="overflow-hidden border border-white/12">
                        <img
                            src={IMG_STONE_DUSK}
                            alt="Contemporary South African home at dusk — an illustration of the homes BuildEase helps homeowners understand"
                            loading="lazy"
                            className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                        />
                    </div>
                    <figcaption className="mt-3 flex items-center justify-between font-mono text-[13px] tracking-[0.22em] text-cad">
                        <span>V.01 — THE FUTURE HOME</span>
                        <span>SOUTH AFRICA</span>
                    </figcaption>
                </motion.figure>
            </div>
        </div>
    </section>
);

export default AboutVision;
